import React from 'react';

import { variablesJSData } from 'data/javascript/variables';

import DescriptionEntry from 'components/shared/description-entry';

const LetExample = () => {
  const item = variablesJSData?.items.find(
    (item) => item.title === 'Variables - let'
  );

  return <DescriptionEntry entry={item} />;
};

export default LetExample;
